import { Component, OnInit, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { MarketingService } from 'src/app/Services/marketing.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-view-ads-popup',
  templateUrl: './view-ads-popup.component.html',
  styleUrls: ['./view-ads-popup.component.scss']
})
export class ViewAdsPopupComponent implements OnInit {
lang:any
AdsSlidersArray=[]
    popupImageIndex:any = 0;
        bannerTypes = [
        { id: 0, name: "none" },
        { id: 1, name: "Product" },
        { id: 2, name: "Subcategory" },
        { id: 3, name: "Medical" },
        { id: 4, name: "Brand" },
        { id: 5, name: "Custom List" },
        { id: 6, name: "Category" },
        { id: 7, name: "Link" },
    ];
    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<ViewAdsPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private router: Router,
        private embryoService: EmbryoService,
        private translate: TranslateService,
        private marketingService: MarketingService,
    ) {
        this.embryoService.emitLang.subscribe((lang: string) => {
            this.lang = lang;
            this.translate.setDefaultLang(lang);
        });

    }

    ngOnInit() {
        this.AdsSlidersArray = this.data;
        if (this.data) {
            this.popupImageIndex = +localStorage.getItem('popupImageIndex')!;
        }
    }


    close(){
        this.dialogRef.close();
    }

    onSlideClick(slide: any) {
        let obj = {
            item_name: slide?.name,
            item_id: slide?.id,
            price: "",
            item_brand: "",
            item_category: this.bannerTypes.filter(
                (type:any) => type.id == slide?.type
            )[0].name,
            promotion_id: slide?.item_id,
            promotion_name: slide?.name,
            creative_name: slide?.image,
            creative_slot: slide?.order,
            location_id: "slider",
            index: this.AdsSlidersArray.findIndex(
                (ad: any) => ad.id == slide?.id
            ),
        };
        if (slide?.type === 0) {
            return;
        }
        else if (slide?.type === 1) {
            this.marketingService.fbTracking("track", "ProductBanner", {
                name: slide?.banner_title || slide?.name,
            });
            this.marketingService.snapTracking("track", "AD_CLICK", {
                description: slide?.banner_title || slide?.name,
            });
 

            this.router.navigateByUrl(
                "/" +
                    this.lang +
                    `/` +
                    slide.slug
            );
            this.dialogRef.close();
        }
        else if (slide?.type > 1 && slide?.type <= 6) {
            const queryParamss: any = {};
            if (slide?.type === 2) {
                this.marketingService.fbTracking("track", "SubCategoryBanner", {
                    name: slide?.name,
                });
                this.marketingService.snapTracking("track", "AD_CLICK", {
                    description: slide?.name,
                });
                queryParamss.sub_category_id = slide?.item_id;
            }
            if (slide?.type === 3) {
                this.marketingService.fbTracking("track", "CategoryBanner", {
                    name: slide?.name,
                });
                this.marketingService.snapTracking("track", "AD_CLICK", {
                    description: slide?.name,
                });
            }
            if (slide?.type === 4) {
                this.marketingService.fbTracking("track", "BrandBanner", {
                    name: slide?.name,
                });
                this.marketingService.snapTracking("track", "AD_CLICK", {
                    description: slide?.name,
                });
                queryParamss.brand_id = slide?.item_id;
            }
            if (slide?.type === 5) {
                this.marketingService.fbTracking("track", "ListBanner", {
                    name: slide?.name,
                });
                this.marketingService.snapTracking("track", "AD_CLICK", {
                    name: slide?.name,
                });
                queryParamss.list_ids = slide?.item_id;
            }
            if (slide?.type === 6) {
                this.marketingService.fbTracking("track", "CategoryBanner", {
                    name: slide?.name,
                });
                this.marketingService.fbTracking("track", "AD_CLICK", {
                    description: slide?.name,
                });
                queryParamss.category_id = slide?.item_id;
            }
            this.router.navigate(["/" + this.lang + "/products"], {
                queryParams: queryParamss,
            });
            this.dialogRef.close();
        }
        else {
            if (slide?.type === 7 && !slide?.extrnal) {
                window.open(slide?.link, "_self");
            }
            else {
                window.open(slide?.link, "_blank");
            }
        }
    }
}
